import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { styles } from './Column.scss';
import './Column.css';

const Column = ({name, s_name, born, die, rzad, sektor, id}) => (
    <div className="Column_l">
        <div className="Column">
            <p className="Text">{name}</p>
            <p className="Text">{s_name}</p>
            <p className="Text">ur:&nbsp;{born}</p>
            <p className="Text">&#10013;{die}</p>
            <p className="Text">Rząd:&nbsp;{rzad}</p>
            <p className="Text">Sektor:&nbsp;{sektor}</p>
            <p className="Text">Id:&nbsp;{id}</p></div>
        <div className="Line"></div>
    </div>
    )

export default withStyles(styles)(Column);



// WEBPACK FOOTER //
// src/components/MapControl/gravePopup/Column.js